export default "__VITE_PUBLIC_ASSET__837ae145__"